"use client";

import React from "react";
import Link from "next/link";
import { useTheme } from "@/components/theme-provider";
import { useSiteSettings } from "@/components/site-settings-provider";

export function BrandLogo({ className }: { className?: string }) {
  const { theme } = useTheme();
  const { settings } = useSiteSettings();
  const brand = settings.branding;

  const isDark = theme === "dark";
  const mode = brand.displayMode || "both";
  const desktopLogo = isDark ? (brand.logoDark || brand.logoLight) : (brand.logoLight || brand.logoDark);
  const mobileLogo = isDark
    ? (brand.mobileLogoDark || brand.logoDark || brand.mobileLogoLight || brand.logoLight)
    : (brand.mobileLogoLight || brand.logoLight || brand.mobileLogoDark || brand.logoDark);
  const textLogo = brand.textLogo || "NotifyStudio";

  const showLogo = mode === "logo" || mode === "both";
  const showText = mode === "text" || mode === "both";
  const hasDistinctMobileLogo = Boolean(mobileLogo && mobileLogo !== desktopLogo);

  return (
    <Link href="/" className={`flex items-center gap-2 shrink-0 ${className ?? ""}`}>
      {showLogo && (
        desktopLogo || mobileLogo ? (
          <>
            {mobileLogo ? (
              <img
                src={mobileLogo}
                alt={textLogo}
                className={`h-9 w-auto object-contain no-transition ${hasDistinctMobileLogo ? "sm:hidden" : ""}`}
              />
            ) : null}
            {desktopLogo ? (
              <img
                src={desktopLogo}
                alt={textLogo}
                className={`h-9 w-auto object-contain no-transition ${hasDistinctMobileLogo ? "hidden sm:block" : mobileLogo ? "hidden" : ""}`}
              />
            ) : null}
          </>
        ) : (
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-blue-600 to-violet-600 flex items-center justify-center">
            <span className="text-white font-bold text-lg">N</span>
          </div>
        )
      )}
      {showText && (
        <span className="font-bold text-xl text-foreground hidden sm:block">
          {textLogo.includes(" ") ? (
            <>
              {textLogo.split(" ")[0]}
              <span className="text-blue-600">{textLogo.split(" ").slice(1).join(" ")}</span>
            </>
          ) : (
            textLogo
          )}
        </span>
      )}
    </Link>
  );
}

export function DynamicFavicon() {
  const { settings } = useSiteSettings();
  const favicon = settings.branding.favicon;

  React.useEffect(() => {
    if (!favicon) return;
    let link = document.querySelector('link[rel="icon"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = favicon;
  }, [favicon]);

  return null;
}
